// @ts-nocheck
import {
    chain,
    LoadRealTimePricingAndInventory as baseLoadRealTimePricingAndInventory,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import loadProductsPricingAndInventory from "@insite/client-framework/Store/Pages/ProductList/Handlers/LoadProductsPricingAndInventory";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadRealTimePricingAndInventory = createChainHandler("LoadRealTimePricingAndInventory", chain, props => {
    /* Store Custom Code - Start */
    const productInfosByProductId = { ...props.result.productInfosByProductId };
    const products = props.result.products?.filter(x => {
        if (!x.isVariantParent) {
            return true;
        }

        delete productInfosByProductId[x.id];
        return false;
    });

    if (!products?.length) {
        return;
    }
    /* Store Custom Code - End */

    props.dispatch(
        loadProductsPricingAndInventory({
            products, // Store Custom Code
            productInfosByProductId, // Store Custom Code
        }),
    );
});

replaceInChain(chain, baseLoadRealTimePricingAndInventory, LoadRealTimePricingAndInventory);
